import React from "react";
import { Wrapper, ContentTop, ContentMid } from "./section.style";
import { useNavigate } from "react-router";

function Section({
  title,
  desc,
  backgroundImg,
  link,
  leftbtn = false,
  rightbtn = true,
  arrow,
}) {
  const navigate = useNavigate();

  const GoTo = (url) => {
    window.location = url;
  };

  const nav = (url, link) => {
    if (link == "external") {
      GoTo(url);
    } else {
      navigate(`/${url}`);
    }
  };

  return (
    <Wrapper bg={backgroundImg[0]}>
      <ContentTop>
        <h1>{title}</h1>
        <p>
          {desc} <a href={link.link}>{link.btntext}</a>
        </p>
      </ContentTop>

      <div>
        <ContentMid className={arrow ? "" : "buttons"}>
          {leftbtn && (
            <div className="left">
              <button
                onClick={() => nav(link.link, "external")}
              >{`VIEW PRODUCT`}</button>
            </div>
          )}
          {rightbtn && (
            <div className="right">
              <button onClick={() => nav(link.link, "external")}>{`VIEW PRODUCT`}</button>
            </div>
          )}
        </ContentMid>
        {/* {<Content></Content>} */}
      </div>
    </Wrapper>
  );
}

export default Section;
